export default __webpack_public_path__ + "static/artificial-intelligence-f46117532ac255e25d94f21e0bc2493b.png";